export const styles = ({
	div: {
    	textAlign: 'center',
        background: 'rgba(156, 156, 156, 0.25)',
        borderRadius: '4px',
        padding: '50vh 50px',
        position: 'absolute',
        zIndex: '1000',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
    },
})

